/** @jsx jsx */
// External modules
import { jsx } from '@emotion/core';
import { LoadingSpinner } from '@checkout/react-components';

// Internal modules
import { getFooterLegalLinks } from './utils';
import { StyledText, TermsLink } from '../Common';
import { CURRENT_YEAR, LINKS_MAP } from './constants';
import { entityMessageStyles, privacyAndSecurityStyles } from './styles';
import {
  $logger,
  buildTermsUrl,
  getContent,
  getGeoRegion,
  getLocale,
  lazyLoader,
} from '@/lib';

const FooterLegalLinks = () => {
  const { country } = getLocale();
  const region = getGeoRegion();
  const links = getFooterLegalLinks(country, region);

  return links.map(link => {
    const config = LINKS_MAP[link];

    if (!config) {
      $logger.warn('footer_link_missing_link_config', { link });
      return null;
    }

    const { contentKey, ...rest } = config;

    return (
      <TermsLink
        href={buildTermsUrl(rest)}
        key={contentKey}
        onClick={() => $logger.info(`weasley_footer_${contentKey}_link_click`)}
        text={getContent(`footer.${contentKey}`)}
      />
    );
  });
};

const LazyCountryChangeInterstitial = lazyLoader({
  loader: () => import('../Locale/Country/Interstitial'),
  loading: () => <LoadingSpinner />,
  name: 'country_change_interstitial',
  render(loaded, props) {
    const Component = loaded.CountryChangeInterstitial;
    return <Component {...props} />;
  },
});

const PrivacyAndSecurityMessage = () => (
  <StyledText css={privacyAndSecurityStyles}>
    {getContent('legalFooter.privacyAndSecurity', {
      cfsgpdsLink: (
        <TermsLink
          href={buildTermsUrl({ path: 'ua/cfsgpds-full' })}
          onClick={() =>
            $logger.info(
              'weasley_footer_privacy_security_message_cfsgpds_link_click',
            )
          }
          text={getContent('compliance.cfsgpds')}
        />
      ),
      privacyStatementLink: (
        <TermsLink
          href={buildTermsUrl({ path: 'ua/privacy-full' })}
          onClick={() =>
            $logger.info(
              'weasley_footer_privacy_security_message_privacy_link_click',
            )
          }
          text={getContent('compliance.privacyPolicy')}
        />
      ),
      userAgreementLink: (
        <TermsLink
          href={buildTermsUrl({ path: 'ua/legalhub-full' })}
          onClick={() =>
            $logger.info(
              'weasley_footer_privacy_security_message_legal_link_click',
            )
          }
          text={getContent('compliance.userAgreement')}
        />
      ),
    })}
  </StyledText>
);

const EntityMessage = () => (
  <StyledText css={entityMessageStyles}>
    {getContent('legalFooter.entity', {
      currentYear: CURRENT_YEAR,
      termsAndConditionsLink: (
        <TermsLink
          href={buildTermsUrl({ path: 'ua/legalhub-full' })}
          onClick={() =>
            $logger.info('weasley_footer__entity_message_legal_link_click')
          }
          text={getContent('compliance.termsAndConditions')}
        />
      ),
    })}
  </StyledText>
);

export {
  EntityMessage,
  FooterLegalLinks,
  LazyCountryChangeInterstitial,
  PrivacyAndSecurityMessage,
};
